/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */

/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { StyleSheet } from 'react-native';
import { ARROW_SIZE } from '@/constants';
import Image from '@components/global/Image';
import PropTypes from 'prop-types';

const propTypes = {
  isMap: PropTypes.string,
  editable: PropTypes.bool,
  right: PropTypes.number,
};

const defaultProps = {
  isMap: '',
  editable: true,
  right: 0,
};

const FormArrow = (props) => {
  const { editable = true, isMap = '', right = 0 } = props;
  return editable && !isMap ? (
    <Image
      style={[ARROW_SIZE, styles.arrow, right ? { right: right } : {}]}
      width={ARROW_SIZE.width}
      height={ARROW_SIZE.height}
      svg={true}
      source={require('@assets/img/icons/arrow-down-grey.svg')}
    />
  ) : (
    false
  );
};

const styles = StyleSheet.create({
  arrow: {
    position: 'absolute',
    top: '40%',
    right: -5,
  },
});

FormArrow.propTypes = propTypes;
FormArrow.defaultProps = defaultProps;

export default React.memo(FormArrow, (prev, next) => prev == next);
